import type { Query, QueryKey } from '@tanstack/react-query';

/**
 * @description v2 api에만 사용가능
 */
export const isSameEndpointQuery = (
  query: Query<unknown, Error, unknown, QueryKey>,
  queryKeys: QueryKey,
) => {
  const [targetQuery] = query.queryKey;
  const [checkQueryKey] = queryKeys;

  if (!targetQuery || !checkQueryKey) return false;

  if (typeof targetQuery !== 'object' || typeof checkQueryKey !== 'object')
    return false;

  if (!('_id' in targetQuery) || !('_id' in checkQueryKey)) return false;

  return targetQuery._id === checkQueryKey._id;
};
